import { render, staticRenderFns } from "./AssumptionsResidentialNewYears.vue?vue&type=template&id=7295a1f0&scoped=true&"
import script from "./AssumptionsResidentialNewYears.vue?vue&type=script&lang=js&"
export * from "./AssumptionsResidentialNewYears.vue?vue&type=script&lang=js&"
import style0 from "./AssumptionsResidentialNewYears.vue?vue&type=style&index=0&id=7295a1f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7295a1f0",
  null
  
)

export default component.exports